import React from 'react';
import { AppState } from '../stores/appStateStore';
import { action } from 'mobx';
import { observer } from 'mobx-react-lite';

interface LoadMoreProps {
    content: string
    state: AppState;
}

const LoadMore = observer((props: LoadMoreProps) => {
    const {content, state} = props;
    if(state.loadedMore) {
        return (
            <div className="plaintext">{content}</div>
        );
    } else {
        return (
            <>
                <div className="plaintext">{content.substring(0, 10000)}</div>
                <div className="flex-mother">
                    <div className="read-more" title="Note: This may cause issues for emails with large attachments." onClick={action(() => {state.loadedMore = true;})}>Load More...</div>
                    <div className="flex-1" />
                </div>
            </>
        );
    }
});

export default LoadMore;